
/**
 * Replaces placeholders in a string with the provided values.
 * @param str The string containing placeholders (e.g., "Hello, {0}").
 * @param values The values to replace the placeholders with.
 * @returns The formatted string.
 */
export function formatString(str: string, ...values: any[]): string {
  return str.replace(/{(\d+)}/g, (match, index) => {
    return typeof values[index] !== 'undefined' ? values[index] : match;
  });
}
